//FGSFGTemplate
import { useState, useEffect } from "react";
import { QRCodeCanvas } from 'qrcode.react';

export default function FGSFGTemplate() {
    let printData = [];

    const rawPrintData = localStorage.getItem('printData') || localStorage.getItem('labelReprintData');

    if (rawPrintData) {
        const parsed = JSON.parse(rawPrintData);
        printData = Array.isArray(parsed)
            ? parsed
            : parsed?.printed_serials || [];
    }


    // window.print();
    // window.close();
    useEffect(() => {
        // Check if print preview has already been shown
        const hasPrinted = sessionStorage.getItem('hasPrinted');

        if (!hasPrinted) {
            window.print();
            sessionStorage.setItem('hasPrinted', true);
        }

        // Automatically close and refresh page after print dialog
        const timer = setTimeout(() => {
            window.close();
            window.location.reload();
        }, 100); // Adjust the delay if needed

        return () => clearTimeout(timer);
    }, []);


    return (
        <>
         <style>
      {`
        @page {
          size: 60mm 25mm;
          margin: 0;
        }

        html, body {
          margin: 0;
          padding: 0;
        }
      `}
    </style>
     
  <div style={{ margin: 0, padding: 0,fontSize:'9px',fontWeight: "500"}}>
    {printData.map((row, index) => (
      <div
      key={index}
      style={{
        width: "58mm",
        minHeight: "25mm",
        padding: "1mm",
        pageBreakAfter: "always",
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between"
      }}
>

  
  <div
    style={{
      textAlign: "center",
      fontWeight: "900",
      lineHeight: "1",
      wordBreak: "break-word",  
    }}
  >
    {row.part_description}
  </div>

 
  <div
    style={{
      display: "flex",
      alignItems: "flex-end",
      justifyContent: "space-between"
    }}
  >

    {/* LEFT TEXT */}
    <div style={{ width: "45%", lineHeight: "1.3" , fontSize: "10px" ,marginBottom:"12px" }}>
      <div><b>Part#</b> : {row.part_number}</div>
      <div><b>JTN#</b> : {row.job_transaction_number}</div>
      <div><b>PO#</b> : {row.production_order_number}</div>
    </div>

    {/* QR */}
    <div style={{ width: "55%", textAlign: "center", fontSize: "7px" }}>
      <QRCodeCanvas size={48} value={row.serial_number} />
      <div style={{ marginTop: "0.5mm", wordBreak: "break-all",fontSize: "9px" }}>
        {row.serial_number}
      </div>
    </div>

  </div>

</div>
    ))}
  </div>
  </>
);

}